import Navbar from "@/components/feature/Navbar";
import { useTheme } from "@/context/ThemeContext";
import Hero from "./components/Hero";
import Scenarios from "./components/Scenarios";
import ProductShowcase from "./components/ProductShowcase";
import Systems from "./components/Systems";
import EngineCapabilities from "./components/EngineCapabilities";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";

export default function Home() {
  const { effectiveTheme } = useTheme();
  const isLight = effectiveTheme === "light";

  return (
    <div
      className={`relative min-h-screen overflow-x-hidden ${
        isLight ? "bg-[#f5f5f7] text-[#1c1c1e]" : "bg-cosmic-950 text-white"
      }`}
    >
      <Navbar />
      <main>
        <Hero />
        <Scenarios />
        <ProductShowcase />
        <Systems />
        <EngineCapabilities />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}